/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import * as types from '../constants/ActionTypes';

/**
 *
 * @param {*} state normal pattern server configuration data will be {isICP: true, docURL, and walkmeURL}
 * @param {*} action
 * @returns
 */
export const serverReducer = (state = {}, action) => {
  switch (action.type) {
    case types.GET_SERVER_CONFIGURATION:
      return { ...state, fetchingData: true };
    case types.GET_SERVER_CONFIGURATION_SUCCESS:
      return { ...state, fetchingData: false, data: action.payload };
    case types.GET_SERVER_CONFIGURATION_FAILURE:
      return { ...state, fetchingData: false, error: action.payload };
    default:
      return state;
  }
};

// return the non-tenant related server details
export const getServerConfiguration = state => state.serverConfiguration.data;

export const isICP = state => state?.serverConfiguration?.data?.isICP;
